export default __webpack_public_path__ + "static/media/loginBackground.80884906.png";